import { render, staticRenderFns } from "./ProfilePlayers.vue?vue&type=template&id=0e838fa7&scoped=true"
import script from "./ProfilePlayers.vue?vue&type=script&lang=js"
export * from "./ProfilePlayers.vue?vue&type=script&lang=js"
import style0 from "./ProfilePlayers.vue?vue&type=style&index=0&id=0e838fa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e838fa7",
  null
  
)

export default component.exports